import React from 'react';
import Style from './Navbar.module.scss';
import { HashLink as Link } from 'react-router-hash-link';
import { Box } from "@mui/material";

const links = [
    {
        name: 'About Me',
        to: 'about',
        active: 'about'
    },
    {
        name: 'Writings',
        to: 'writings',
        active: 'writings'
    },
    {
        name: 'Portfolio',
        to: 'portfolio',
        active: 'portfolio'
    },
    {
        name: 'Contact Me',
        to: 'contact',
        active: 'contact'
    }
]

const scrollWidthOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; 
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
}

export default function Navbar({ active, setActive }) {

    return (
        <Box component={'nav'} width={'100%'}>
            <Box className={Style.container}>
                <Link to={'#about'} className={Style.brand} scroll={el => scrollWidthOffset(el)}>
                    Hi, I'm Alif
                </Link>
                <Box component={'ul'} className={Style.navLinks}>
                    {links.map((link, index) => (
                        <Box key={index} component={'li'}>
                            <Link 
                                to={`#${link.to}`}
                                scroll={el => scrollWidthOffset(el)}
                                smooth
                                onClick={() => setActive(link.active)} 
                                className={`${Style.navLink} ${active === link.active ? Style.active : ''}`}
                            >
                                {link.name}
                            </Link>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}
